export default "__VITE_ASSET__D9L6yttt__"